import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';

const RoleSwitcher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userRoles, setUserRoles] = useState([]);
  const [activeRole, setActiveRole] = useState('');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    // Load user data from localStorage
    const roles = JSON.parse(localStorage.getItem('user_roles') || '[]');
    const currentRole = localStorage.getItem('active_role') || '';
    const email = localStorage.getItem('user_email') || '';
    
    setUserRoles(roles);
    setActiveRole(currentRole);
    setUserEmail(email);
  }, [location]);

  // Only show if user has multiple roles
  if (userRoles.length <= 1) {
    return null;
  }

  const handleSwitchRole = () => {
    // Switch between available roles
    const otherRole = userRoles.find(role => role !== activeRole);
    
    if (otherRole) {
      // Update active role in localStorage
      localStorage.setItem('active_role', otherRole);
      setActiveRole(otherRole);
      
      // Navigate to the appropriate dashboard
      if (otherRole === 'carrier') {
        navigate(`/carrier-dashboard?email=${encodeURIComponent(userEmail)}`);
      } else if (otherRole === 'shipper') {
        navigate(`/shipper-dashboard?email=${encodeURIComponent(userEmail)}`);
      }
    }
  };

  const getOtherRoleName = () => {
    const otherRole = userRoles.find(role => role !== activeRole);
    return otherRole ? otherRole.charAt(0).toUpperCase() + otherRole.slice(1) : '';
  };

  return (
    <button
      onClick={handleSwitchRole}
      className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[#1e3a5f] hover:bg-[#2d5a8f] rounded-lg transition-colors shadow-sm"
      title={`Switch to ${getOtherRoleName()} Portal`}
    >
      <RefreshCw size={16} />
      <span className="hidden sm:inline">Switch to {getOtherRoleName()}</span>
      <span className="sm:hidden">{getOtherRoleName()}</span>
    </button>
  );
};

export default RoleSwitcher;
